import { trpc } from "../../../utils/trpc";
import { useServerId } from "./use_server_id";

export function useSetBookmarkMutation(onSuccess?: () => void) {
	const context = trpc.useContext();
	const server_id = useServerId();

	return trpc.event_template.setBookmark.useMutation({
		onSuccess: (data) => {
			context.event_template.getBookmarkedList.setData(
				(old_data) => {
					const new_data = [...old_data];
					new_data.push(data);
					new_data.sort(
						(a, b) =>
							new Date(b.created_at).getTime() -
							new Date(a.created_at).getTime()
					);
					return new_data;
				},
				{
					guild_id: server_id,
				}
			);
			context.event_template.getBookmarkedList.invalidate({
				guild_id: server_id,
			});

			onSuccess?.();
		},
	});
}
